import { useEffect, useRef } from 'react';

const testimonials = [
  {
    text: 'Alianza Andina estructuró el financiamiento para nuestro complejo hotelero en tiempo récord. Su profesionalismo y transparencia en todo el proceso fueron excepcionales.',
    name: 'Carlos Mendoza',
    role: 'CEO, Grupo Inversiones del Sur',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Latin%20American%20male%20business%20executive%20in%20his%2050s%2C%20wearing%20dark%20suit%20and%20tie%2C%20confident%20expression%2C%20neutral%20dark%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality%2C%20professional%20lighting&width=200&height=200&seq=avatar-01&orientation=squarish',
  },
  {
    text: 'Gracias a su respaldo financiero, logramos expandir nuestra operación logística a tres países adicionales. Un socio estratégico de verdad.',
    name: 'María Elena Ríos',
    role: 'Directora General, LogiAndes',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Latin%20American%20female%20business%20executive%20in%20her%2040s%2C%20wearing%20elegant%20business%20attire%2C%20confident%20smile%2C%20neutral%20dark%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality%2C%20professional%20lighting&width=200&height=200&seq=avatar-02&orientation=squarish',
  },
  {
    text: 'El proceso fue transparente desde el primer día. Cumplieron con cada plazo y la estructura financiera fue perfecta para nuestro proyecto de infraestructura.',
    name: 'Andrés Felipe Torres',
    role: 'Gerente de Proyectos, Construcciones Andinas',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Latin%20American%20male%20engineer%20in%20his%2030s%2C%20wearing%20formal%20business%20casual%2C%20confident%20expression%2C%20neutral%20dark%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality%2C%20professional%20lighting&width=200&height=200&seq=avatar-03&orientation=squarish',
  },
  {
    text: 'La flexibilidad de plazos que nos ofrecieron fue clave para el éxito de nuestra expansión agroindustrial. Recomendados al 100%.',
    name: 'Isabella Gómez',
    role: 'Fundadora, AgroSoluciones',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Latin%20American%20female%20entrepreneur%20in%20her%2030s%2C%20wearing%20modern%20business%20attire%2C%20warm%20confident%20smile%2C%20neutral%20dark%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality%2C%20professional%20lighting&width=200&height=200&seq=avatar-04&orientation=squarish',
  },
  {
    text: 'Habíamos intentado con bancos tradicionales sin éxito. Alianza Andina entendió nuestro modelo y estructuró la solución perfecta.',
    name: 'Roberto Castillo',
    role: 'Director, Inversiones Patrimoniales',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Latin%20American%20male%20senior%20executive%20in%20his%2060s%2C%20wearing%20premium%20suit%2C%20distinguished%20expression%2C%20neutral%20dark%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality%2C%20professional%20lighting&width=200&height=200&seq=avatar-05&orientation=squarish',
  },
];

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.testimonial-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.classList.add('animate-fade-in-up');
                (card as HTMLElement).style.opacity = '1';
              }, i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonios" className="relative bg-aa-black py-16 md:py-24 overflow-hidden">
      {/* Gold accent background */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-aa-gold/[0.02] to-transparent pointer-events-none" />

      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <i className="ri-vip-diamond-line text-aa-gold" />
              <span className="label-tag">TESTIMONIOS</span>
            </div>
            <h2 className="heading-display text-3xl md:text-4xl lg:text-5xl font-bold">
              Confianza <span className="gold-text-gradient">Andina</span>
            </h2>
          </div>

          {/* Testimonials Grid */}
          <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((t, index) => (
              <div
                key={index}
                className="testimonial-card opacity-0 rounded-2xl bg-aa-black-card border border-aa-gold/10 p-6 md:p-8 gold-border-glow flex flex-col"
              >
                {/* Quote Icon */}
                <div className="mb-4">
                  <i className="ri-double-quotes-l text-aa-gold/30 text-3xl" />
                </div>

                {/* Text */}
                <p className="text-aa-gray-100 text-sm leading-relaxed flex-1 mb-6">
                  {t.text}
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-aa-gold/10">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover border-2 border-aa-gold/40"
                  />
                  <div>
                    <p className="text-white text-sm font-medium">{t.name}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}